import React from "react"
import ReactDOM from "react-dom"
import { Controller } from "stimulus"

import { ReoccurringReportForm } from "components/ReportForm"

import { isPreview } from "../../utils/turbolinks"

class ReportController extends Controller {
  idValue: string

  static values = {
    id: String
  }

  connect() {
    if (isPreview()) return
    ReactDOM.render(<ReoccurringReportForm reoccurringReportId={this.idValue} />, this.element)
  }

  disconnect() {
    ReactDOM.unmountComponentAtNode(this.element)
  }
}

export default ReportController
